import { styled } from '@mui/material';

export const StyledUL = styled('ul')(({ theme }) => ({
  color: theme.palette.primary.main,
}));
